import isNil from 'lodash/isNil';
import cloneDeep from 'lodash/cloneDeep';

// 是否null undefined 空字符串
const isEmpty = (val) => {
  return isNil(val) || val === '';
};

// 是否存在值
const exsit = (val) => {
  return isEmpty(val) === false;
};

// 是否null undefined 空字符串 false 0
const isFalse = (val) => {
  return isEmpty(val) || !val;
};

// 是否空字典
const isEmptyObject = (obj) => {
  if (!obj) {
    return false;
  }

  for (const key in obj) {
    return false;
  }

  return true;
};

// 是否有效字典（至少存在一个key）
const validDict = (obj) => {
  if (isFalse(obj)) {
    return false;
  }
  if (isEmptyObject(obj)) {
    return false;
  }
  return true;
};

// 是否有效数组（至少存在一个元素）
const validArray = (arr) => {
  if (Array.isArray(arr) === false) {
    return false;
  }
  if (arr.length === 0) {
    return false;
  }
  return true;
};

// 安全的取值
const getValidValue = (data) => {
  if (isNil(data)) {
    return '';
  }
  return data;
};

// 截取字符串，剩下的代之以 ...
const getValueWithMax = (data, len) => {
  if (!data) {
    return '';
  }
  if (typeof data === 'string' && data.length > len) {
    return data.substring(0, len) + '...';
  }
  return data;
};

// 手机号加密
const secretMobile = (mobile) => {
  if (!mobile) {
    return '';
  }
  try {
    const m = parseInt(mobile, 10);
    return (m).toString(32);
  } catch (e) {
    return '';
  }
};

// 手机号揭秘
const decretMobile = (mobile) => {
  if (!mobile) {
    return '';
  }
  try {
    return parseInt(mobile, 32);
  } catch (e) {
    return '';
  }
};

// 随机数
const rnd = (n, m) => {
  const random = Math.floor(Math.random() * (m - n + 1) + n);
  return random;
};

// 千字符处理
const toThousands = (val) => {
  let num = val;

  if (!num) return num;

  let info = null;

  if (num.toString().indexOf('.') === -1) {
    info = parseFloat(num).toString().split('.');
  } else {
    info = parseFloat(num).toFixed(2).toString().split('.');
  }

  num = info[0];
  let result = '';
  while (num.length > 3) {
    result = `,${num.slice(-3)}${result}`;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  info[0] = result;
  return info.join('.');
};

// 将字符串转为json格式
export const toJsonWithComma = (v) => {
  const vs = v.split(';');
  const json = {};

  vs.map(item => {
    if (item !== '') {
      const items = item.split(':');
      if (items.length > 1) {
        json[items[0].trim()] = items[1];
      } else {
        json[items[0]] = '';
      }
    }
    return item;
  });

  return json;
};

// 获取随机数
const randomNum = (minNum, maxNum) => {
  return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
};

// 判断是否函数
const isFn = (fn) => {
  return typeof fn === 'function';
};

// debug模式
const debug = () => {
  return window.location.href.indexOf('debug=1') > -1;
};

const sort = (list, fn) => {
  return cloneDeep(list).sort(fn);
};

// 节流
function throttle(fn, mustRun = 500) {

  let previous = null;

  return function () {

    const now = new Date();
    const context = this;
    const args = arguments;

    if (!previous) {
      previous = 1;
    }

    const remaining = now - previous;

    if (mustRun && remaining >= mustRun) {
      fn.apply(context, args);
      previous = now;
    }

  };

}

// 防抖
function debounce(fn, wait = 2000) {

  let timeout;

  return function () {

    const context = this;
    const args = arguments;

    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      fn.apply(context, args);
    }, wait);
  };
}

const getOpenId = (parm) => {
  if (!parm) {
    return null;
  }

  return parm.openId || parm.openid;
};

const getAppId = (parm) => {
  if (!parm) {
    return null;
  }

  return parm.appId || parm.appid;
};

export default {
  isNil,
  isEmpty,
  exsit,
  isFalse,
  isEmptyObject,
  getValidValue,
  getValueWithMax,
  validDict,
  validArray,
  secretMobile,
  decretMobile,
  rnd,
  toThousands,
  toJsonWithComma,
  randomNum,
  isFn,
  debug,
  throttle,
  debounce,
  sort,
  getOpenId,
  getAppId,
};
